import {Module, Role} from '../../../core/model/profile';
import {environment} from '../../../../environments/environment';
import {AuthStorage} from "../../../core/auth/auth-storage";

export const menuItems = [
  {
    title: 'menu.monitor',
    routerLink: '/monitor',
    id: 'menu-monitor',
    icon: 'ico-monitor',
    selected: false,
    active: false,
    expanded: false,
    order: 0,
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
      Role.ROLE_CLIENT_ENGINEER,
      Role.ROLE_PARTNER_EMPLOYEE,
      Role.ROLE_CLIENT_SENIOR_MANAGER
    ],
  },
  {
    title: 'menu.carrier-vehicles',
    routerLink: '/carrier-vehicles',
    id: 'menu-carrier-vehicles',
    icon: 'ico-truck',
    selected: false,
    active: false,
    expanded: false,
    order: 0,
    roles: [Role.ROLE_PARTNER_EMPLOYEE],
  },
  {
    title: 'menu.fleet.title',
    routerLink: '/fleet',
    id: 'menu-fleet',
    icon: 'ico-truck',
    selected: false,
    active: false,
    expanded: false,
    order: 1,
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
      Role.ROLE_CLIENT_ENGINEER,
      Role.ROLE_CLIENT_SENIOR_MANAGER],
    subMenu: [
      {
        active: false,
        title: 'menu.fleet.vehicles',
        routerLink: '/vehicles',
        id: 'menu-vehicles',
        icon: 'ico-truck'
      },
      {
        active: false,
        title: 'menu.fleet.vehicles-group',
        routerLink: '/groups',
        id: 'menu-groups',
        icon: 'ico-group'
      },
      {
        active: false,
        title: 'menu.fleet.track',
        routerLink: '/vehicles/track',
        id: 'menu-vehicles-track',
        icon: 'ico-road'
      },
      {
        active: false,
        title: 'menu.fleet.integrations',
        routerLink: '/vehicles/integrations',
        id: 'menu-vehicles-integrations',
        icon: 'ico-puzzle'
      },
      {
        active: false,
        title: 'menu.fleet.detached-tablets',
        routerLink: '/vehicles/detached-tablets',
        id: 'menu-detached-tablets',
        icon: 'ico-tablet',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_ENGINEER
        ],
      }
    ]
  },
  {
    title: 'menu.employees.title',
    routerLink: '/coworkers',
    id: 'menu-coworkers',
    icon: 'ico-personnel',
    selected: false,
    active: false,
    expanded: false,
    order: 1,
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
      Role.ROLE_CLIENT_ENGINEER,
      Role.ROLE_CLIENT_SENIOR_MANAGER],
    subMenu: [
      {
        active: false,
        title: 'menu.employees.clients-employees',
        routerLink: '/colleagues',
        id: 'menu-colleagues',
        icon: 'ico-users'
      },
      {
        active: false,
        title: 'menu.employees.department',
        routerLink: '/department',
        id: 'menu-department',
        icon: 'ico-hierarchy'
      },
      {
        active: false,
        title: 'menu.employees.drivers',
        routerLink: '/drivers',
        id: 'menu-drivers',
        icon: 'ico-wheel'
      }
    ]
  },
  {
    title: 'menu.partners.title',
    routerLink: '/partner',
    id: 'menu-partner',
    icon: 'ico-suitcase',
    selected: false,
    active: false,
    expanded: false,
    order: 1,
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
      Role.ROLE_CLIENT_ENGINEER,
      Role.ROLE_CLIENT_SENIOR_MANAGER],
    subMenu: [
      {
        active: false,
        title: 'menu.partners.partners',
        routerLink: '/partners',
        id: 'menu-partners',
        icon: 'ico-suitcase'
      },
      {
        active: false,
        title: 'menu.partners.partners-employee',
        routerLink: '/partners-employees',
        id: 'menu-partners-employees',
        icon: 'ico-user-card'
      },
      {
        active: false,
        title: 'menu.partners.partners-vehicles',
        routerLink: '/shared-vehicles',
        id: 'menu-shared-vehicles',
        icon: 'ico-truck-head'
      },
      {
        active: false,
        title: 'menu.partners.partners-positions',
        routerLink: '/shared-positions',
        id: 'menu-shared-positions',
        icon: 'ico-map-marker'
      },
      {
        active: false,
        title: 'menu.partners.partner-docs',
        routerLink: '/partners-docs',
        id: 'menu-partners-docs',
        icon: 'ico-pdf',
        modules: [Module.ORDERS],
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
      }
    ]
  },
  {
    title: 'menu.alarms.title',
    routerLink: '/',
    id: 'menu-alarms-notices',
    icon: 'ico-attention-triangle',
    selected: false,
    active: false,
    expanded: false,
    order: 1,
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
      Role.ROLE_CLIENT_ENGINEER,
      Role.ROLE_CLIENT_SENIOR_MANAGER
    ],
    modules: [Module.ALARM],
    subMenu: [
      {
        active: false,
        title: 'menu.alarms.alarms',
        routerLink: '/alarms',
        id: 'menu-alarms',
        icon: 'ico-attention-triangle'
      },
      {
        active: false,
        title: 'menu.alarms.notices',
        routerLink: '/notices',
        id: 'menu-notices',
        icon: 'ico-attention-circle'
      },
      {
        active: false,
        title: 'menu.alarms.personal',
        routerLink: '/personal',
        id: 'menu-personal',
        icon: 'ico-alarm'
      }
    ]
  },
  {
    title: 'menu.reports.title',
    routerLink: '/reports',
    id: 'menu-reports',
    icon: 'ico-chart-pie',
    selected: false,
    active: false,
    expanded: false,
    order: 1,
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
      Role.ROLE_CLIENT_ENGINEER,
      Role.ROLE_PARTNER_EMPLOYEE,
      Role.ROLE_CLIENT_SENIOR_MANAGER
    ],
    partnerModules: [Module.VIEW_REPORT],
    subMenu: [
      {
        active: false,
        title: 'menu.reports.accounting',
        id: 'menu-reports-accounting',
        icon: 'ico-book',
        modules: [Module.HEAVY_TRACK],
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
        subMenu: [
          {
            active: false,
            title: 'menu.reports.hours',
            routerLink: '/reports/hours',
            id: 'menu-reports-hours',
            icon: 'ico-calendar',
          },
          {
            active: false,
            title: 'menu.reports.times',
            routerLink: '/reports/times',
            id: 'menu-reports-times',
            icon: 'ico-clock',
          },
          {
            active: false,
            title: 'menu.reports.country',
            routerLink: '/reports/country',
            id: 'menu-reports-country',
            icon: 'ico-globe',
          },
          {
            active: false,
            title: 'menu.reports.time-list',
            routerLink: '/reports/time-list',
            id: 'menu-reports-time-list',
            icon: 'ico-table',
          },
        ]
      },
      {
        active: false,
        title: 'menu.reports.driving',
        id: 'menu-reports-driving',
        icon: 'ico-wheel',
        subMenu: [
          {
            active: false,
            title: 'menu.reports.period',
            routerLink: '/reports/period',
            id: 'menu-reports-period',
            icon: 'ico-old-status'
          },
          {
            active: false,
            title: 'menu.reports.work',
            routerLink: '/reports/work',
            id: 'menu-reports-work',
            icon: 'ico-gear'
          },
          {
            active: false,
            title: 'menu.reports.travel',
            routerLink: '/reports/travel',
            id: 'menu-reports-travel',
            icon: 'ico-odometer'
          }
        ]
      },
      {
        active: false,
        title: 'menu.reports.tacho.tacho',
        id: 'menu-reports-tacho',
        icon: 'ico-tachograph',
        modules: [Module.HEAVY_TRACK],
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
        subMenu: [
          {
            active: false,
            title: 'menu.reports.tacho.charts',
            routerLink: '/reports/tacho-charts',
            id: 'menu-reports-tacho-charts',
            icon: 'ico-chart-bar'
          },
          {
            active: false,
            title: 'menu.reports.tacho.tables',
            routerLink: '/reports/tacho-tables',
            id: 'menu-reports-tacho-tables',
            icon: 'ico-table'
          },
          {
            active: false,
            title: 'menu.reports.tacho.latestWork',
            routerLink: '/reports/latest-work',
            id: 'menu-reports-latest-work',
            icon: 'ico-old-status'
          },
          {
            active: false,
            title: 'menu.reports.tacho.countryHours',
            routerLink: '/reports/country-hours',
            id: 'menu-reports-country-hours',
            icon: 'ico-car',
          },
          {
            active: false,
            title: 'menu.reports.tacho.driverCountryHours',
            routerLink: '/reports/driver-country-hours',
            id: 'menu-reports-driver-country-hours',
            icon: 'ico-user',
          },
          {
            active: false,
            title: 'menu.reports.tacho.driverFaults',
            routerLink: '/reports/tacho-faults',
            id: 'menu-reports-tacho-faults',
            icon: 'ico-attention-triangle',
            modules: [Module.TACHO_ANALYTICS],
          },
          {
            active: false,
            title: 'menu.reports.tacho.driversFaults',
            routerLink: '/reports/tacho-multi-faults',
            id: 'menu-reports-tacho-multi-faults',
            icon: 'ico-violation',
            modules: [Module.TACHO_ANALYTICS],
          }
        ]
      },
      {
        active: false,
        title: 'menu.reports.eco',
        id: 'menu-reports-eco',
        icon: 'ico-leaf',
        modules: [Module.HEAVY_TRACK],
        hideInMobile: true,
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
        subMenu: [
          {
            active: false,
            title: 'menu.reports.eco-drivers',
            routerLink: '/reports/eco-drivers',
            id: 'menu-reports-eco-drivers',
            icon: 'ico-user-card'
          },
          {
            active: false,
            title: 'menu.reports.eco-driver',
            routerLink: '/reports/eco-driver',
            id: 'menu-reports-eco-driver',
            icon: 'ico-wheel'
          },
          {
            active: false,
            title: 'menu.reports.eco-vehicle',
            routerLink: '/reports/eco-vehicle',
            id: 'menu-reports-eco-vehicle',
            icon: 'ico-truck'
          },
          {
            active: false,
            title: 'menu.reports.eco-multi-vehicle',
            routerLink: '/reports/eco-multi-vehicle',
            id: 'menu-reports-eco-multi-vehicle',
            icon: 'ico-car'
          },
          {
            active: false,
            title: 'menu.reports.eco-vehicle-group-configs',
            routerLink: '/reports/eco-vehicle-group-configs',
            id: 'menu-reports-eco-vehicle-group-configs',
            icon: 'ico-sliders'
          }
        ]
      },
      {
        active: false,
        title: 'menu.reports.tasks',
        id: 'menu-reports-tasks',
        icon: 'ico-check',
        modules: [Module.MANAGEMENT],
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
        subMenu: [
          {
            active: false,
            title: 'menu.reports.empty-kilometers',
            routerLink: '/reports/empty-kilometers',
            id: 'menu-reports-empty-kilometers',
            icon: 'ico-road',
            onlyForClients: environment.name === 'PREPROD' ? [450] : [6601, 6600, 6450]
          },
          {
            active: false,
            title: 'menu.reports.status-report',
            class: 'hidden-md-down',
            routerLink: '/reports/status-report',
            id: 'menu-reports-status-report',
            icon: 'ico-behind-schedule',
          },
          {
            active: false,
            title: 'menu.reports.detailed-status',
            routerLink: '/reports/detailed-status',
            id: 'menu-reports-detailed-status',
            icon: 'ico-review'
          },
          {
            active: false,
            title: 'menu.reports.taskReport',
            routerLink: '/reports/tasks-report',
            id: 'menu-reports-tasks-report',
            icon: 'ico-doc-check'
          },
          {
            active: false,
            title: 'menu.reports.task-delay-report',
            routerLink: '/reports/task-delay',
            id: 'menu-reports-task-delay',
            icon: 'ico-unload-truck'
          },
          {
            active: false,
            title: 'menu.reports.preliminary-route-report',
            routerLink: '/reports/preliminary-route',
            id: 'menu-reports-preliminary-route',
            icon: 'ico-route',
            onlyForClients: [6601, 6600, 6450]
          },
          {
            active: false,
            title: 'menu.reports.trailer-swap-report',
            routerLink: '/reports/trailer-swap',
            id: 'menu-reports-trailer-swap',
            icon: 'ico-trailer',
            modules: [Module.TRAILER_SWAP]
          }
        ]
      },
      {
        active: false,
        title: 'menu.reports.track',
        icon: 'ico-road',
        id: 'menu-reports-track',
        modules: [Module.HEAVY_TRACK],
        subMenu: [
          {
            active: false,
            title: 'menu.reports.locations',
            routerLink: '/reports/locations',
            id: 'menu-reports-locations',
            icon: 'ico-map-pin'
          },
          {
            active: false,
            title: 'menu.reports.countryChange',
            routerLink: '/reports/country-change',
            id: 'menu-reports-country-change',
            icon: 'ico-flag'
          },
          // {
          //   title: 'menu.reports.tachoCountry',
          //   routerLink: '/reports/tacho-country',
          //   icon: 'ico-finish',
          //   modules: [Module.HEAVY_TRACK],
          //   roles: [Role.ROLE_CLIENT_EMPLOYEE_ADMIN],
          //   contractor: true
          // }
        ]
      },
      {
        active: false,
        title: 'menu.reports.freezer',
        routerLink: '/reports/freezer',
        id: 'menu-reports-freezer',
        icon: 'ico-snowflake',
        modules: [Module.HAS_FREEZERS],
      },
      {
        active: false,
        title: 'menu.reports.system',
        id: 'menu-reports-system',
        icon: 'ico-gears',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
        subMenu: [
          {
            active: false,
            title: 'menu.reports.video',
            routerLink: '/reports/video',
            id: 'menu-reports-video',
            icon: 'ico-dvr',
            modules: [Module.VIDEO]
          },
          {
            active: false,
            title: 'menu.reports.object-history',
            class: 'hidden-md-down',
            routerLink: '/reports/object-history',
            id: 'menu-reports-object-history',
            icon: 'ico-old-status',
            roles: [
              Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
              Role.ROLE_CLIENT_ENGINEER,
              Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
              Role.ROLE_CLIENT_SENIOR_MANAGER
            ],
            modules: [Module.HEAVY_TRACK]
          }
        ]
      },
      {
        active: false,
        title: 'menu.reports.fuel',
        id: 'menu-reports-fuel',
        icon: 'ico-fuel',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
        subMenu: [
          {
            active: false,
            title: 'menu.reports.fuel-change',
            routerLink: '/reports/fuel/change',
            id: 'menu-reports-fuel-change',
            icon: 'ico-truck'
          },
          {
            active: false,
            title: 'menu.reports.fuel-change-by-country',
            routerLink: '/reports/fuel/change-by-country',
            id: 'menu-reports-fuel-change-by-country',
            icon: 'ico-globe'
          },
          {
            active: false,
            title: 'menu.reports.fuel-transactions',
            routerLink: '/reports/fuel/transactions',
            id: 'menu-reports-fuel-transactions',
            icon: 'ico-credit-card'
          },
          {
            active: false,
            title: 'menu.reports.fuelling-replanning',
            routerLink: '/reports/fuel/fuelling-replanning',
            id: 'menu-reports-fuel-fuelling-replanning',
            icon: 'ico-refresh',
            modules: [Module.AI_ROUTING, Module.AI_SMART_ROUTING]
          },
          {
            active: false,
            title: 'menu.reports.offered-replan',
            routerLink: '/reports/fuel/offered-replan',
            id: 'menu-reports-offered-replan',
            icon: 'ico-route',
            modules: [Module.AI_ROUTING, Module.AI_SMART_ROUTING]
          },
          {
            active: false,
            title: 'menu.reports.trips-report',
            routerLink: '/reports/fuel/trips-report',
            id: 'menu-reports-trips-report',
            icon: 'ico-suitcase',
            modules: [Module.AI_SMART_ROUTING]
          },
          {
            active: false,
            title: 'menu.reports.replan-savings',
            routerLink: '/reports/fuel/replan-savings',
            id: 'menu-reports-replan-savings',
            icon: 'ico-money',
            modules: [Module.AI_ROUTING, Module.AI_SMART_ROUTING],
            ignorePermissions: [AuthStorage.isCollectFuellingReplan()]
          }
        ]
      },
      {
        active: false,
        title: 'menu.reports.orders',
        routerLink: '/reports/orders',
        id: 'menu-reports-orders',
        icon: 'ico-clipboard',
        modules: [Module.ORDERS],
        hideInMobile: true
      },
      {
        active: false,
        title: 'menu.geo-zones.title',
        routerLink: '/geo-zones',
        id: 'menu-reports-geo-zones',
        icon: 'ico-map',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
        subMenu: [
          {
            active: false,
            title: 'menu.geo-zones.hits',
            routerLink: '/geo-zones/hits',
            id: 'menu-reports-geo-zones-hits',
            icon: 'ico-border-crossing'
          },
          {
            active: false,
            title: 'menu.geo-zones.stops',
            routerLink: '/geo-zones/stops',
            id: 'menu-reports-geo-zones-stops',
            icon: 'ico-rest-area'
          }
        ]
      },
      {
        active: false,
        title: 'menu.poi.parkingBooking',
        routerLink: '/poi/parking-booking',
        id: 'menu-reports-parking-booking',
        icon: 'ico-parking',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
        modules: [Module.HEAVY_TRACK],
      }
    ]
  },
  {
    title: 'menu.services.title',
    routerLink: '/service',
    id: 'menu-service',
    icon: 'ico-service',
    selected: false,
    active: false,
    expanded: false,
    order: 1,
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_ENGINEER,
      Role.ROLE_CLIENT_SENIOR_MANAGER,
      Role.ROLE_CLIENT_EMPLOYEE_MANAGER
    ],
    subMenu: [
      {
        active: false,
        title: 'menu.services.current',
        routerLink: '/service/current',
        id: 'menu-service-current',
        icon: 'ico-bookmark-full',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER
        ]
      },
      {
        active: false,
        title: 'menu.services.history',
        routerLink: '/service/history',
        id: 'menu-service-history',
        icon: 'ico-check',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER
        ],
      },
      {
        active: false,
        title: 'menu.services.issues',
        routerLink: '/service/issues',
        id: 'menu-service-issues',
        icon: 'ico-attention-circle',
        modules: [Module.SERVICES],
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER
        ],
      },
      {
        active: false,
        title: 'menu.services.repairOrders',
        routerLink: '/service/repair-orders',
        id: 'menu-service-repair-orders',
        icon: 'ico-doc',
        modules: [Module.SERVICES],
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER
        ],
      },
      {
        active: false,
        title: 'menu.services.invoices',
        routerLink: '/service/invoices',
        id: 'menu-service-invoices',
        icon: 'ico-credit-card',
        modules: [Module.INVOICE_ADMIN],
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER
        ],
      },
      {
        active: false,
        title: 'menu.services.report',
        routerLink: '/service/report',
        id: 'menu-service-report',
        icon: 'ico-chart-pie',
        modules: [Module.HEAVY_TRACK],
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER,
        ],
      },
      {
        active: false,
        title: 'menu.services.defects',
        routerLink: '/service/defects',
        id: 'menu-service-defects',
        icon: 'ico-general-malfunction',
        modules: [Module.MANAGEMENT],
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER,
        ],
      },
      {
        active: false,
        title: 'menu.services.configuration',
        id: 'menu-service-configuration',
        icon: 'ico-gear',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER
        ],
        subMenu: [
          {
            active: false,
            title: 'menu.services.service',
            routerLink: '/service/service',
            id: 'menu-service-service',
            icon: 'ico-book',
            roles: [
              Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
              Role.ROLE_CLIENT_ENGINEER,
              Role.ROLE_CLIENT_SENIOR_MANAGER,
              Role.ROLE_CLIENT_EMPLOYEE_MANAGER
            ],
          },
          {
            active: false,
            title: 'menu.services.workTypes',
            routerLink: '/service/work-types',
            id: 'menu-service-work-types',
            icon: 'ico-bookmark',
            modules: [Module.SERVICES],
            roles: [
              Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
              Role.ROLE_CLIENT_ENGINEER,
              Role.ROLE_CLIENT_SENIOR_MANAGER,
              Role.ROLE_CLIENT_EMPLOYEE_MANAGER
            ],
          },
          {
            active: false,
            title: 'menu.services.statusTypes',
            routerLink: '/service/status-types',
            id: 'menu-service-status-types',
            icon: 'ico-flag',
            modules: [Module.SERVICES],
            roles: [
              Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
              Role.ROLE_CLIENT_ENGINEER,
              Role.ROLE_CLIENT_SENIOR_MANAGER,
              Role.ROLE_CLIENT_EMPLOYEE_MANAGER
            ],
          },
          {
            active: false,
            title: 'menu.services.tags',
            routerLink: '/service/tags',
            id: 'menu-service-tags',
            icon: 'ico-tag',
            modules: [Module.SERVICES],
            roles: [
              Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
              Role.ROLE_CLIENT_ENGINEER,
              Role.ROLE_CLIENT_SENIOR_MANAGER,
              Role.ROLE_CLIENT_EMPLOYEE_MANAGER
            ],
          },
          {
            active: false,
            title: 'menu.services.parts',
            routerLink: '/service/parts',
            id: 'menu-service-parts',
            icon: 'ico-puzzle',
            modules: [Module.SERVICES],
            roles: [
              Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
              Role.ROLE_CLIENT_ENGINEER,
              Role.ROLE_CLIENT_SENIOR_MANAGER,
              Role.ROLE_CLIENT_EMPLOYEE_MANAGER
            ],
          },
          {
            active: false,
            title: 'menu.services.laborTypes',
            routerLink: '/service/labor-types',
            id: 'menu-service-labor-types',
            icon: 'ico-user-card',
            modules: [Module.SERVICES],
            roles: [
              Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
              Role.ROLE_CLIENT_ENGINEER,
              Role.ROLE_CLIENT_SENIOR_MANAGER,
              Role.ROLE_CLIENT_EMPLOYEE_MANAGER
            ],
          },
          {
            active: false,
            title: 'menu.services.inventory',
            routerLink: '/service/inventory',
            id: 'menu-service-inventory',
            icon: 'ico-archive',
            modules: [Module.MANAGEMENT],
            roles: [
              Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
              Role.ROLE_CLIENT_ENGINEER,
              Role.ROLE_CLIENT_SENIOR_MANAGER,
              Role.ROLE_CLIENT_EMPLOYEE_MANAGER
            ],
          }
        ]
      }
    ]
  },
  {
    title: 'menu.documents.title',
    routerLink: '/documents',
    id: 'menu-documents',
    icon: 'ico-doc',
    selected: false,
    active: false,
    expanded: false,
    order: 1,
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
      Role.ROLE_CLIENT_ENGINEER,
      Role.ROLE_CLIENT_SENIOR_MANAGER
    ],
    modules: [Module.HEAVY_TRACK],
    subMenu: [
      {
        active: false,
        title: 'menu.documents.ddd',
        routerLink: '/documents/ddd',
        id: 'menu-documents-ddd',
        icon: 'ico-tachograph',
        class: 'hidden-sm-down',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ]
      },
      {
        active: false,
        title: 'menu.documents.forms',
        routerLink: '/documents/vehicle-change',
        id: 'menu-documents-vehicle-change',
        icon: 'ico-doc-check',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ]
      },
      {
        active: false,
        title: 'menu.documents.group-files',
        routerLink: '/documents/group-files',
        id: 'menu-documents-group-files',
        icon: 'ico-users',
        class: 'hidden-sm-down',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ]
      },
      {
        active: false,
        title: 'menu.documents.tripExpensesForms',
        id: 'menu-documents-trip-expenses-forms',
        icon: 'ico-suitcase',
        class: 'hidden-sm-down',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
        subMenu: [
          {
            active: false,
            title: 'menu.documents.tripForms',
            routerLink: '/documents/trip-sheets',
            id: 'menu-documents-trip-sheets',
            icon: 'ico-doc-check'
          },
          {
            active: false,
            title: 'menu.documents.expensesForms',
            routerLink: '/documents/expenses-sheets',
            id: 'menu-documents-expenses-sheets',
            icon: 'ico-form-filled'
          },
          {
            active: false,
            title: 'menu.documents.expenses',
            routerLink: '/documents/expenses',
            id: 'menu-documents-expenses',
            icon: 'ico-money'
          }
        ]
      },
      {
        active: false,
        title: 'menu.documents.freezerForm',
        routerLink: '/documents/freezer-form',
        id: 'menu-documents-freezer-form',
        icon: 'ico-snowflake',
        class: 'hidden-sm-down',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ]
      },
      {
        active: false,
        title: 'menu.documents.fillRules',
        routerLink: '/documents/fill-rules',
        id: 'menu-documents-fill-rules',
        icon: 'ico-pdf',
        class: 'hidden-sm-down',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_ENGINEER
        ]
      },
      {
        active: false,
        title: 'menu.documents.activities',
        routerLink: '/documents/activity',
        id: 'menu-documents-activity',
        icon: 'ico-doc-check',
        modules: [Module.HAS_ACTIVITIES],
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ]
      },
      {
        active: false,
        title: 'menu.documents.documentRules',
        routerLink: '/documents/document-rules',
        id: 'menu-documents-document-rules',
        icon: 'ico-doc-check',
        modules: [Module.AI_DOCUMENT_VALIDATION],
        roles: [Role.ROLE_CLIENT_EMPLOYEE_ADMIN]
      }
    ]
  },
  {
    title: 'menu.orders.title',
    routerLink: '/orders',
    id: 'menu-orders',
    icon: 'ico-clipboard',
    selected: false,
    active: false,
    expanded: false,
    order: 1,
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_SENIOR_MANAGER
    ],
    modules: [Module.ORDERS],
    class: 'hidden-sm-down',
    subMenu: [
      {
        active: false,
        title: 'menu.orders.orders',
        routerLink: '/orders/orders',
        id: 'menu-orders-orders',
        icon: 'ico-clipboard'
      },
      {
        active: false,
        title: 'menu.orders.serial-numbers',
        routerLink: '/orders/serial-numbers',
        id: 'menu-orders-serial-numbers',
        icon: 'ico-barcode'
      },
      {
        active: false,
        title: 'menu.orders.invoices',
        routerLink: '/orders/invoices',
        id: 'menu-orders-invoices',
        icon: 'ico-receipt',
        roles: [Role.ROLE_CLIENT_EMPLOYEE_ADMIN]
      },
      {
        active: false,
        title: 'menu.orders.expenses',
        routerLink: '/orders/expenses',
        id: 'menu-orders-expenses',
        icon: 'ico-money',
        roles: [Role.ROLE_CLIENT_EMPLOYEE_ADMIN]
      },
      {
        active: false,
        title: 'menu.orders.point',
        routerLink: '/orders/points',
        id: 'menu-orders-points',
        icon: 'ico-lane-departure',
        roles: [Role.ROLE_CLIENT_EMPLOYEE_ADMIN]
      }
    ]
  },
  {
    title: 'planning.title',
    routerLink: '/planning',
    id: 'menu-planning',
    icon: 'ico-tasks',
    selected: false,
    active: false,
    expanded: false,
    order: 1,
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
      Role.ROLE_CLIENT_ENGINEER,
      Role.ROLE_CLIENT_SENIOR_MANAGER
    ],
    modules: [Module.PLANNING],
    class: 'hidden-sm-down',
    onlyForClients: [18070],
    subMenu: [
      {
        active: false,
        title: 'menu.planning.sheets',
        routerLink: '/planning/sheets',
        icon: 'ico-table'
      }
      // {
      //   active: false,
      //   title: 'planning.panner',
      //   routerLink: '/planning',
      //   id: 'menu-planning-planner',
      //   icon: 'ico-chart-gantt'
      // },
      // {
      //   active: false,
      //   title: 'planning.regions.regions',
      //   routerLink: '/planning/regions',
      //   id: 'menu-planning-regions',
      //   icon: 'ico-list'
      // }
    ]
  },
  {
    title: 'menu.calendar.title',
    routerLink: '/calendar',
    id: 'menu-calendar',
    icon: 'ico-calendar',
    selected: false,
    active: false,
    expanded: false,
    order: 1,
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
      Role.ROLE_CLIENT_ENGINEER,
      Role.ROLE_CLIENT_SENIOR_MANAGER
    ],
    modules: [Module.CALENDAR],
    class: 'hidden-sm-down'
  },
  {
    title: 'menu.map-assets.title',
    icon: 'ico-map-tools',
    routerLink: '/route',
    id: 'menu-route',
    selected: false,
    active: false,
    expanded: false,
    order: 1,
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_SENIOR_MANAGER
    ],
    subMenu: [
      {
        active: false,
        title: 'menu.geo-zones.planner',
        id: 'menu-route-geo-zones-planner',
        icon: 'ico-map',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
        subMenu: [
          {
            active: false,
            title: 'menu.geo-zones.geozones',
            routerLink: '/geo-zones/planner',
            id: 'menu-route-geo-zones-planner-list',
            icon: 'ico-map'
          },
          {
            active: false,
            title: 'menu.geo-zones.groups',
            routerLink: '/geo-zones/group',
            id: 'menu-route-geo-zones-planner-groups',
            icon: 'ico-group'
          }
        ]
      },
      {
        active: false,
        title: 'menu.poi.title',
        id: 'menu-route-poi',
        icon: 'ico-location',
        class: 'hidden-sm-down',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
        modules: [Module.HEAVY_TRACK],
        subMenu: [
          {
            active: false,
            title: 'menu.poi.poi',
            routerLink: '/poi/poi',
            id: 'menu-route-poi-poi',
            icon: 'ico-map-marker'
          },
          {
            active: false,
            title: 'menu.poi.group',
            routerLink: '/poi/group',
            id: 'menu-route-poi-group',
            icon: 'ico-poi'
          },
          {
            active: false,
            title: 'menu.marked-roads',
            routerLink: '/marked-roads',
            id: 'menu-route-poi-marked-roads',
            icon: 'ico-road'
          },
          {
            active: false,
            title: 'menu.poi.fuelStations',
            routerLink: '/poi/fuel-stations',
            id: 'menu-route-poi-fuel-stations',
            icon: 'ico-fuel'
          },
          {
            active: false,
            title: 'menu.poi.parkingManagement',
            routerLink: '/poi/parking-management',
            id: 'menu-route-poi-parking-management',
            icon: 'ico-parking',
            modules: [Module.AI_SMART_ROUTING]
          }
        ]
      },
      {
        active: false,
        title: 'menu.map-assets.preferable',
        routerLink: '/route/preferable',
        id: 'menu-route-preferable',
        icon: 'ico-route',
        modules: [Module.AI_ROUTING, Module.AI_SMART_ROUTING],
      },
      {
        active: false,
        title: 'menu.rules.title',
        routerLink: '/rules/rule-sets',
        id: 'menu-route-rules',
        icon: 'ico-sliders',
        roles: [
          Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
          Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
          Role.ROLE_CLIENT_ENGINEER,
          Role.ROLE_CLIENT_SENIOR_MANAGER
        ],
        modules: [Module.AI_SMART_ROUTING],
        subMenu: [
          {
            active: false,
            title: 'menu.rules.title',
            routerLink: '/rules/rule-sets',
            id: 'menu-route-rules',
            icon: 'ico-sliders',
            roles: [
              Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
              Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
              Role.ROLE_CLIENT_ENGINEER,
              Role.ROLE_CLIENT_SENIOR_MANAGER
            ],
          },
          {
            active: false,
            title: 'menu.rules.vehicle-groups',
            routerLink: '/rules/vehicle-groups',
            id: 'menu-vehicle-groups',
            icon: 'ico-truck',
            roles: [
              Role.ROLE_CLIENT_EMPLOYEE_ADMIN
            ]
          },
          {
            active: false,
            title: 'menu.rules.driver-groups',
            routerLink: '/rules/driver-groups',
            id: 'menu-driver-groups',
            icon: 'ico-wheel',
            roles: [
              Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
              Role.ROLE_CLIENT_EMPLOYEE_MANAGER,
              Role.ROLE_CLIENT_ENGINEER,
              Role.ROLE_CLIENT_SENIOR_MANAGER
            ]
          }
        ]
      }
    ]
  },
  {
    title: 'menu.agentic.title',
    routerLink: '/agentic-flows',
    id: 'menu-agentic',
    icon: 'ico-ai',
    selected: false,
    active: false,
    expanded: false,
    order: 1,
    modules: [Module.AGENTIC_FLOWS],
    roles: [
      Role.ROLE_CLIENT_EMPLOYEE_ADMIN,
      Role.ROLE_CLIENT_SENIOR_MANAGER
    ],
    subMenu: [
      {
        active: false,
        title: 'menu.agentic.flows',
        routerLink: '/agentic-flows',
        id: 'menu-agentic-flows',
        icon: 'ico-chat'
      },
      {
        active: false,
        title: 'menu.agentic.summaries',
        routerLink: '/agentic-flows/summaries',
        id: 'menu-agentic-summaries',
        icon: 'ico-note-reminder'
      }
    ]
  }
];
